<template>
    <div>
        <div class="btn-group">
            <button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                Datasets <span class="caret"></span>
            </button>
            <toolbar-link
                fieldName="datasets"
                :status="status"
                @click="click"
            />
        </div>
        <div class="btn-group">
            <button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                Distributions <span class="caret"></span>
            </button>
            <toolbar-link
                fieldName="distributions"
                :status="status"
                @click="click"
            />
        </div>
        <div class="btn-group">
            <button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                Path <span class="caret"></span>
            </button>
            <toolbar-link
                fieldName="paths"
                :status="status"
                @click="click"
            />
        </div>
        <div class="btn-group">
            <button @click="reload" type="button" class="btn btn-outline-info btn-sm" data-toggle="tooltip" data-placement="top" title="Reset graph to initial state">
                Reload
            </button>
        </div>

        <div class="pull-right">
            <a class="cursor-hover" @click="zoom('decrease')">
                <i class="fas fa-search-minus fa-lg"
                    data-toggle="tooltip" data-placement="top" title="Zoom in" />
            </a>
            <a class="cursor-hover" @click="zoom('increase')">
                <i class="fas fa-search-plus fa-lg"
                    data-toggle="tooltip" data-placement="top" title="Zoom out" />
            </a>
            <a class="cursor-hover" @click="resize()">
                <i v-if="!isExpanded" class="fas fa-expand-arrows fa-lg"
                    data-toggle="tooltip" data-placement="top" title="View graph in full screen" />
                <i v-else class="fas fa-compress-arrows-alt fa-lg"
                    data-toggle="tooltip" data-placement="top" title="View graph in normal screen"/>
            </a>
        </div>
    </div>
</template>

<script>
import ToolbarLink from '@/graphs/data_lineage/ToolbarLink.vue'

export default {
    components: {
        ToolbarLink
    },
    props: {
        isExpanded: {
            type: Boolean,
            requied: true
        },
        // The status of lines displayed for each type [dataset, distribution, path]
        status: {
            type: Object,
            required: true
        }
    },
    methods: {
        zoom(type) {
            this.$emit('zoom', type)
        },
        resize() {
            this.$emit('resize')
        },
        click(fieldName, action) {
            this.$emit('click', fieldName, action)
        },
        reload() {
            this.$emit('reload')
        }
    }
}
</script>

<style scoped>
.cursor-hover {
    cursor: pointer
}
.dashed {
  border:none;
  border-top:1px dashed black;
  color:#fff;
  background-color:#fff;
}
</style>
